import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Link } from "react-router-dom";

const Stat = ({ label, value, href }) => (
  <Link to={href || "#"} className="admin-card hover:border-[var(--crest-gold)] transition-colors block" data-testid={`stat-${label.toLowerCase().replace(/\s+/g, "-")}`}>
    <div className="eyebrow text-[var(--crest-muted)]">{label}</div>
    <div className="font-serif text-4xl mt-2">{value}</div>
  </Link>
);

export default function AdminOverview() {
  const [stats, setStats] = useState({});
  const [bookings, setBookings] = useState([]);
  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
    api.get("/admin/bookings").then((r) => setBookings(r.data.slice(0, 6))).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-overview">
      <div className="flex items-end justify-between mb-8">
        <div>
          <div className="eyebrow text-[var(--crest-gold)]">— Overview</div>
          <h1 className="font-serif text-4xl md:text-5xl tracking-tight mt-2">Studio Dashboard</h1>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Stat label="Bookings" value={stats.bookings_total ?? "—"} href="/admin/bookings" />
        <Stat label="Paid Deposits" value={stats.bookings_paid ?? "—"} href="/admin/bookings" />
        <Stat label="Pending" value={stats.bookings_pending ?? "—"} href="/admin/bookings" />
        <Stat label="Clients" value={stats.clients_total ?? "—"} href="/admin/clients" />
        <Stat label="Active Projects" value={stats.projects_active ?? "—"} href="/admin/projects" />
        <Stat label="Intake Forms" value={stats.intake_total ?? "—"} href="/admin/intake" />
        <Stat label="Newsletter" value={stats.newsletter_total ?? "—"} href="/admin/newsletter" />
        <Stat label="Creator Apps" value={stats.creator_applications ?? "—"} href="/admin/creators" />
      </div>

      <div className="mt-12 admin-card">
        <div className="flex items-center justify-between">
          <h2 className="font-serif text-2xl">Recent Bookings</h2>
          <Link to="/admin/bookings" className="text-xs tracking-widest uppercase gold" data-testid="overview-bookings-link">View all</Link>
        </div>
        <div className="mt-6 divide-y divide-black/10">
          {bookings.length === 0 && <div className="text-sm text-[var(--crest-muted)] py-6">No bookings yet.</div>}
          {bookings.map((b) => (
            <div key={b._id} className="py-4 grid grid-cols-12 gap-4 items-center text-sm" data-testid={`overview-booking-${b._id}`}>
              <div className="col-span-3 font-medium">{b.client_name}</div>
              <div className="col-span-3 text-[var(--crest-muted)]">{b.client_email}</div>
              <div className="col-span-3">{b.service_interest}</div>
              <div className="col-span-3">
                <span className="pill"><span className="pill-dot" /> {b.status}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
